import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { on, off } from 'toolbox/event';

/**
 * This is a description of the ProductInfoUpdater constructor function.
 * @class
 * @classdesc This is a description of the ProductInfoUpdater class. (must be edited)
 * @extends Component
 */
export default class ProductInfoUpdater extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            dataModelId: null,
            templateName: null,
            showOnProductUpdate: false,
            visibleProducts: [],
            replaceChildren: false,
        }, options));
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        on('product.updated', this.element, this.onProductUpdated.bind(this));
    }

    /**
     * Cache selectors
     */
    initCache() {
        this.classNames = {
            hidden: 'h-hidden',
        };
    }

    /**
     * Update component on product updated event
     *
     * @param {Object} event - event data
     */
    onProductUpdated(event) {
        if (this.options.showOnProductUpdate) {
            this.showOnProductUpdate(event);
            return;
        }

        const model = event.detail.data && event.detail.data[this.options.dataModelId];
        if (model) {
            if (model.suppressRender && this.options.replaceChildren) {
                while (this.element.firstChild) {
                    this.element.removeChild(this.element.firstChild);
                }
            } else if (this.options.templateName) {
                this.render(model, { replaceChildren: this.options.replaceChildren });
            }
        }
    }

    /**
     * Show or hide on product updated event
     *
     * @param {Object} event - event data
     */
    showOnProductUpdate(event) {
        const element = this.options.showTargetSelector
            ? this.element.querySelector(this.options.showTargetSelector)
            : this.element;

        if (this.options.visibleProducts.indexOf(event.detail.pid) !== -1) {
            element.classList.remove(this.classNames.hidden);
        } else {
            element.classList.add(this.classNames.hidden);
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off(this.element);
    }
}
